// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../cache-deps/virtual-store/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status[data-v-6d3f26a4]{display:flex;width:5rem;align-items:center;justify-content:center;border-radius:.75rem;padding-top:.5rem;padding-bottom:.5rem;font-family:Lato;font-size:.75rem;line-height:1rem;font-weight:500;--tw-text-opacity:1;color:rgba(255,255,255,var(--tw-text-opacity))}.status-active[data-v-6d3f26a4]{background:#43cdb4}.status-inactive[data-v-6d3f26a4]{background:#f15a5a}", ""]);
// Exports
module.exports = exports;
